module.exports = __webpack_public_path__ + "static/media/36.76bf5c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/36.jpg
// module id = 405
// module chunks = 0